import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query';
import { QK } from '../consts/query-keys';
import {
    addFavoriteFilter,
    deleteFavoriteFilter,
    getFavoriteFilterById,
    getFavoriteFiltersList,
} from '../services/api/filter/favoriteFilterApi';
import {
    FavoriteFilterList,
    RequestPostFavoriteFilter,
    ResponseGetFavoriteFilter,
    ResponsePostFavoriteFilter,
} from '../services/api/filter/types';

export const useGetFavoriteFilters = () =>
    useQuery<FavoriteFilterList>({
        queryKey: [QK.FAVORITE_FILTERS.ALL],
        queryFn: getFavoriteFiltersList,
    });

export const usePostFavoriteFilter = () => {
    const qc = useQueryClient();

    return useMutation<ResponsePostFavoriteFilter, unknown, RequestPostFavoriteFilter>({
        mutationKey: [QK.FAVORITE_FILTERS.POST],
        mutationFn: (payload) => addFavoriteFilter(payload),
        onSuccess: (created) => {
            qc.invalidateQueries({ queryKey: [QK.FAVORITE_FILTERS.ALL] });
        },
    });
};

export const useDeleteFavoriteFilter = () => {
    const qc = useQueryClient();

    return useMutation<void, unknown, string>({
        mutationKey: [QK.FAVORITE_FILTERS.DELETE],
        mutationFn: (id) => deleteFavoriteFilter(id),
        onSuccess: (created) => {
            qc.invalidateQueries({ queryKey: [QK.FAVORITE_FILTERS.ALL] });
        },
    });
};

export const useGetFavoriteFilter = () => {
    const qc = useQueryClient();

    return useMutation<ResponseGetFavoriteFilter, unknown, string>({
        mutationKey: [QK.FAVORITE_FILTERS.GET],
        mutationFn: (id) => getFavoriteFilterById(id),
        onSuccess: (data) => {
            qc.invalidateQueries({ queryKey: [QK.FAVORITE_FILTERS.ALL] });
        },
    });
};
